import Nav from "@/components/Nav";
import PageHero from "@/components/PageHero";
import MarketingFooter from "@/components/MarketingFooter";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { motion } from "framer-motion";

const MOMENTS = [
  { src: "https://images.unsplash.com/photo-1735052712464-9d24b69be5f5?fm=jpg&w=900&auto=format&fit=crop&q=80", caption: "Aditya & Meghana", city: "Hyderabad · matched in 12 days" },
  { src: "https://images.unsplash.com/photo-1727430256509-0f897d6f4765?fm=jpg&w=900&auto=format&fit=crop&q=80", caption: "Rohit & Priyanka", city: "Bengaluru → Pune · matched in 9 days" },
  { src: "https://images.unsplash.com/photo-1600685890506-593fdf55949b?fm=jpg&w=900&auto=format&fit=crop&q=80", caption: "Sonal & Karan", city: "Delhi · matched in 3 weeks" },
  { src: "https://images.unsplash.com/photo-1735052712489-f45220126a0c?fm=jpg&w=900&auto=format&fit=crop&q=80", caption: "Vikram & Shreya", city: "London → Delhi · NRI match" },
  { src: "https://images.unsplash.com/photo-1591604466107-ec97de577aff?fm=jpg&w=900&auto=format&fit=crop&q=80", caption: "Nikhil & Anisha", city: "Mumbai · matched in 15 days" },
  { src: "https://images.unsplash.com/photo-1665960213508-48f07086d49c?fm=jpg&w=900&auto=format&fit=crop&q=80", caption: "Kabir & Aditi", city: "Chandigarh · matched in 8 days" },
  { src: "https://images.unsplash.com/photo-1587271636175-90d58cdad458?fm=jpg&w=900&auto=format&fit=crop&q=80", caption: "Family blessings · Jaipur", city: "The elders read the report together" },
  { src: "https://images.unsplash.com/photo-1639979511572-ff346bc5b3b7?fm=jpg&w=900&auto=format&fit=crop&q=80", caption: "The Sharma family", city: "Two families, one blessing" },
];

export default function Moments() {
  return (
    <div className="min-h-screen bg-[#F9F8F6]">
      <Nav variant="marketing" />
      <PageHero
        overline="Real Anubandh Moments"
        sanskrit="स्मृति · आनंद · अनुबंध"
        title={<>Quiet joys. Real weddings. <span className="italic text-amber-300">No stock clichés.</span></>}
        subtitle="Every image on this page is a moment from a real couple who found their bond through Anubandh.ai — or one that inspired us to build it. No stagey pretend-couples. No filters. Just real weddings and the quiet joy that follows."
      >
        <div className="flex flex-wrap gap-3">
          <Link to="/signup" data-testid="moments-signup" className="btn-pill bg-amber-500 text-[#12103A] text-sm px-6 py-3 font-medium inline-flex items-center gap-2">
            Begin your story <ArrowRight size={16} />
          </Link>
        </div>
      </PageHero>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {MOMENTS.map((m, i) => (
            <motion.figure
              key={m.src}
              initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-60px" }}
              transition={{ delay: i * 0.04 }}
              className="group rounded-2xl overflow-hidden border border-stone-200 bg-white"
            >
              <div className="aspect-[4/5] overflow-hidden">
                <img
                  src={m.src}
                  alt={m.caption}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <figcaption className="p-4">
                <div className="font-serif-display text-lg text-[#1E1B4B]">{m.caption}</div>
                <div className="text-xs text-stone-500 mt-1">{m.city}</div>
              </figcaption>
            </motion.figure>
          ))}
        </div>

        <div className="mt-16 rounded-2xl p-10 text-center bg-white border border-stone-200">
          <div className="overline">Would you like to be featured?</div>
          <h3 className="font-serif-display text-3xl text-[#1E1B4B] mt-2 leading-tight">
            Send us your Anubandh moment.
          </h3>
          <p className="mt-4 text-stone-600 max-w-xl mx-auto">
            If you matched through Anubandh.ai, we&apos;d love to share your story here (with your
            permission). Every real couple lifts a hundred more into clarity.
          </p>
          <div className="mt-6">
            <a
              href="mailto:hello@anubandh.ai?subject=Our Anubandh Moment"
              data-testid="moments-share-story"
              className="btn-pill inline-flex text-white px-7 py-3 text-sm"
              style={{ background: "#1E1B4B" }}
            >
              Share your story
            </a>
          </div>
        </div>
      </section>

      <MarketingFooter />
    </div>
  );
}
